// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { TOP_IMAGES } from '../../../../../assets/imgs';

export default function News(props) {
  const { news } = props;

  return (
    <>
      {news && (
        <a className="news" href={`/news/${news.id}`}>
          <div
            className="list-news-item AOTFShinMaruGoPro news-PC"
            style={{
              background: `url(${TOP_IMAGES.NewsItem}) 100% no-repeat`,
              backgroundSize: '100%',
            }}
          >
            <div className="list-news-created_date">{news.created_date}</div>
            <div className="list-news-item-title">{news.title}</div>
          </div>
          <div
            className="list-news-item AOTFShinMaruGoPro news-SP"
            style={{
              background: `url(${TOP_IMAGES.NewsItemSP}) 100% no-repeat`,
              backgroundSize: '100% 100%',
            }}
          >
            <div className="list-news-created_date">{news.created_date}</div>
            <div className="list-news-item-title">{news.title}</div>
          </div>
        </a>
      )}
    </>
  );
}
